// Marque des documents (logo et tampon) par structure.
// Module volontairement autonome : il n'importe pas le store, pour que les
// rendus HTML/PDF et leurs tests restent utilisables sans initialisation.
import { LOGO_CYGNATURE_DATA_URI } from './logoDataUri';
import { TAMPON_SIGNATURE_DATA_URI } from './annexesDataUri';

export type StructureCode = 'cygnature' | 'suivez_vos_reves';

type Brand = { logo?: string; tampon?: string };

const brandByStructure: Partial<Record<StructureCode, Brand>> = {};

/** Enregistre le logo / tampon personnalisé d'une structure (vidé = retour au défaut). */
export function setDocumentBrand(structure: StructureCode, brand: Brand): void {
  brandByStructure[structure] = { logo: brand.logo || undefined, tampon: brand.tampon || undefined };
}

/** Logo à afficher : celui de la structure si renseigné, sinon le logo par défaut. */
export function logoSrc(structure?: StructureCode | string | null): string {
  return (structure && brandByStructure[structure as StructureCode]?.logo) || LOGO_CYGNATURE_DATA_URI;
}

/** Tampon / signature à apposer : celui de la structure si renseigné, sinon le tampon par défaut. */
export function tamponSrc(structure?: StructureCode | string | null): string {
  return (structure && brandByStructure[structure as StructureCode]?.tampon) || TAMPON_SIGNATURE_DATA_URI;
}
